import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { SaveFamilyOnboardingRequest } from '$/requests/SaveFamilyOnboarding.ts';

const useSaveFamilyOnboarding = () => {
  const client = supabaseClient;

  const mutationFn = async (request: SaveFamilyOnboardingRequest) => {
    return saveFamilyOnboarding(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useSaveFamilyOnboarding;

async function saveFamilyOnboarding(
  client: SupabaseClient,
  request: SaveFamilyOnboardingRequest
): Promise<BackendSuccessResponse<{ message: string }>> {
  const { data, error } = await client.functions.invoke('save_family_onboarding', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}

